class ImageHelper {
	async createImg(imgSrc) {
		return new Promise((resolve, reject) => {
			let img = new Image()
			img.onload = () => resolve(img)
			img.onerror = reject
			img.src = imgSrc
		}).then(img => {
			return img;
			});
	}
	
	async resizeImage(file, image, newWidth, newHeight) {
		let img = await this.createImg( image );
		if(img.height > newHeight || img.width > newWidth) {
            if(img.height > img.width) {
                newWidth = Math.floor(newHeight * (img.width / img.height));
            } else {
                newHeight = Math.floor(newWidth * (img.height / img.width));
            }

            let resizingCanvas:HTMLCanvasElement = document.createElement('canvas');
            let resizingCanvasContext = resizingCanvas.getContext("2d");

            // Start with original image size
            resizingCanvas.width = img.width;
            resizingCanvas.height = img.height;


            // Draw the original image on the (temp) resizing canvas
            resizingCanvasContext.drawImage(img, 0, 0, resizingCanvas.width, resizingCanvas.height);

            let curImageDimensions = {
                width: Math.floor(img.width),
                height: Math.floor(img.height)
            };

            let halfImageDimensions = {
                width: null,
                height: null
            };
            while (curImageDimensions.width * 0.5 > newWidth) {
                // Reduce the resizing canvas by half and refresh the image
                halfImageDimensions.width = Math.floor(curImageDimensions.width * 0.5);
                halfImageDimensions.height = Math.floor(curImageDimensions.height * 0.5);

                resizingCanvasContext.drawImage(resizingCanvas, 0, 0, curImageDimensions.width, curImageDimensions.height,
                    0, 0, halfImageDimensions.width, halfImageDimensions.height);

                curImageDimensions.width = halfImageDimensions.width;
                curImageDimensions.height = halfImageDimensions.height;
            }

            let outputCanvas:HTMLCanvasElement = document.createElement('canvas');
            let outputCanvasContext = outputCanvas.getContext("2d");

            outputCanvas.width = newWidth;
            outputCanvas.height = newHeight;

            outputCanvasContext.drawImage(resizingCanvas, 0, 0, curImageDimensions.width, curImageDimensions.height,
                0, 0, newWidth, newHeight);

            // output the canvas pixels as an image. params: format, quality
            let url = outputCanvas.toDataURL(file.type, .5);
			let newFile = await fetch(url)
				.then(res => res.blob())
				.then(blob => {
					const retFile = new File([blob], file.name ,{ type: file.type });
					return retFile;
				})

			return newFile;
		}
		return file;
	}
}

export default new ImageHelper();